import { createFileRoute } from '@tanstack/react-router'
import { requiredRoles } from '@/shared/utils/require-roles'
import { InvoicePreviewPage } from '@/pages/invoice/preview-page'

export const Route = createFileRoute(
  '/_invoice-flow/org/$orgId/invoices/$invoiceId/preview'
)({
  // SUPER_ADMIN only — every action on this screen is an Invoice create/update/
  // delete, which the API grants to no other role; anyone else gets the 403
  // page, not a form whose every save fails (#2421).
  beforeLoad: () => {
    requiredRoles([])
  },
  component: InvoicePreviewPage,
})
